export default function Setting() {
    return (
        <>
            <h1>Setting</h1>
        </>
    );
}
